import { render, staticRenderFns } from "./ImgDialog.vue?vue&type=template&id=b7382514"
import script from "./ImgDialog.vue?vue&type=script&lang=js"
export * from "./ImgDialog.vue?vue&type=script&lang=js"
import style0 from "./ImgDialog.vue?vue&type=style&index=0&id=b7382514&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports